import script from "./TcTabs.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TcTabs.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcTabs.vue?vue&type=script&setup=true&lang=ts"

import "./TcTabs.vue.scss?vue&type=style&index=0&id=adf4f822&lang=scss&scoped=true!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcTabs.vue?vue&type=style&index=0&id=adf4f822&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adf4f822"]])

export default __exports__